export const LoadingIndicator: React.FC<{ isLoading: boolean }> = ({
  isLoading,
}) =>
  isLoading ? (
    <div className="flex justify-center py-2">
      <div className="h-4 w-4 animate-spin rounded-full border-b-2 border-blue-500"></div>
    </div>
  ) : null;
